import { axiosClientv1 } from "./apiClient";
import { ApiResponse } from "../Types";

export const GetRestaurantTables = async (params?: {
  search?: string;
  status?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/restaurant-tables`, { params });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load tables.",
      data: { data: [] },
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const CreateRestaurantTable = async (payload: {
  name: string;
  description?: string;
  status?: string;
  store_id?: string | null;
  current_status?: string | null;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(
      `/restaurant-tables/create`,
      payload,
    );
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to create table.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const UpdateRestaurantTable = async (payload: {
  id: string;
  name: string;
  description?: string;
  status?: string;
  store_id?: string | null;
  current_status?: string | null;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(
      `/restaurant-tables/update`,
      payload,
    );
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to update table.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const UpdateRestaurantTableStatus = async (payload: {
  id: string;
  status: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(
      `/restaurant-tables/status`,
      payload,
    );
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to update status.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const DeleteRestaurantTable = async (payload: {
  id: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(
      `/restaurant-tables/delete`,
      payload,
    );
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to delete table.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};
